import { Affix, Button, Transition, rem } from '@mantine/core';
import { useWindowScroll } from '@mantine/hooks';
import { IconArrowUp } from '@tabler/icons-react';

export function ScrollTop() {
  const [scroll, scrollTo] = useWindowScroll();

  return (
    <Affix position={{ bottom: 20, right: 20 }}>
      <Transition transition="slide-up" mounted={scroll.y > 0}>
        {(transitionStyles) => (
          <Button
            radius={50}
            style={{ ...transitionStyles, backgroundColor:'var(--ultron-button-color)', borderRadius: '50%', height:'3rem'}}
            onClick={() => scrollTo({ y: 0 })}
          ><IconArrowUp style={{ width: rem(16), height: rem(16) }} /></Button>
        )}
      </Transition>
    </Affix>
  );
}